export default "__VITE_ASSET__eddadc4b__"